import { Speciality } from '@/modules/MedicalSpecialities/classes/Speciality'
import { Medic } from '@/modules/Attendance/classes/Medic'
import {
  SCHEDULED_ATTENDANCE,
  SCHEDULED_ATTENDANCE_W_PREFERENCE,
} from '@/modules/Attendance/constants'
import { TrackingAttendanceOrigin } from '../store/trackingAttendanceOrigin'

export default class Attendance {
  private _date: string
  public hour: string
  private _medic: Medic
  public patientContact: { cellphone: string; email: string }
  public healthInsuranceCardId: number | null = null
  public rescheduleToken: string
  public selectedPreferenceType:
    | 'from_without_preference'
    | 'from_speciality'
    | 'from_medic_name' = null

  public selectedSpecialityId: string | number
  public selectedSpecialityName: string
  public selectedCouncil: string | number
  public scheduleId: number
  public origin: TrackingAttendanceOrigin | null = null
  public isReservation?: boolean

  // eslint-disable-next-line no-useless-constructor
  constructor(private _speciality?: Speciality) {}

  get date(): string {
    return this._date
  }

  set date(value: string) {
    this._date = value
  }

  get speciality(): Speciality {
    return this._speciality
  }

  get medic(): Medic {
    return this._medic
  }

  set medic(value: Medic) {
    this._medic = value
  }

  type(): string {
    if (this._date && this._medic) return SCHEDULED_ATTENDANCE
    if (this._date && !this._medic) return SCHEDULED_ATTENDANCE_W_PREFERENCE
  }
}
